import React, { forwardRef } from 'react';

const TextInput = forwardRef(({ label, name, error, ...rest }, ref) => {
  return (
    <div className="mb-4">
      <label className="pb-1 text-lg font-semibold" htmlFor={name}>
        {label}
      </label>
      <input
        id={name}
        name={name}
        ref={ref} // forwardRef passes ref to input
        className={`w-full border ${error ? 'border-red-500' : 'border-gray-300'} p-2`}
      {...rest}
        
      />
      {error && <p className="text-red-500 text-xs italic">{error}</p>}
    </div>
  );
});

export default TextInput;
